<template>
  <div class="uploadfile">


    <!-- Element Plus 上传组件 -->
    <el-upload ref="uploadRef" class="upload-demo" drag :action="uploadUrl" :headers="uploadHeaders" :data="uploadData"
      :before-upload="beforeUpload" :on-success="handleUploadSuccess" :on-error="handleUploadError"
      :on-progress="handleUploadProgress" v-model:file-list="fileList" :auto-upload="false" :accept="'.xlsx,.xls'"
      :limit="100" :multiple="true" :on-exceed="handleExceed" :on-change="handleFileChange">
      <template #trigger>
        <div class="upload-trigger">
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将文件拖到此处,或<em>点击选择</em>
          </div>
        </div>
      </template>
      <template #tip>
        <div class="el-upload__tip">
          支持批量选择多个文件(最多100个)
        </div>
      </template>
    </el-upload>

    <!-- 操作按钮 -->
    <div class="upload-actions">

      <el-button v-if="fileList.length > 0" @click="clearFiles">清空文件</el-button>

      <!-- 选择下载文件夹按钮 -->
      <el-button @click="handleSelectFolder" type="info" v-if="!isMobile">
        {{ savedDirectoryHandle ? '已选择下载文件夹' : '选择下载文件夹(桌面)' }}
      </el-button>

      <el-button @click="batchProcessFiles" type="primary" :loading="batchProcessing">
        {{ batchProcessing ? '批量处理中...' : '批量处理所有文件' }}
      </el-button>

    </div>

    <transition name="fade">
      <div v-if="batchProgressVisible" class="batch-progress-panel">
        <div class="progress-header">
          <span>{{ batchProgressTitle }}</span>
          <span class="current-file" v-if="currentProcessingFile">{{ currentProcessingFile }}</span>
        </div>
        <el-progress
          :percentage="batchProgress"
          :stroke-width="16"
          text-inside
          striped
          striped-flow
          :duration="12"
          :color="progressColors" />
        <div class="progress-footer">
          <span>{{ batchProcessedCount }}/{{ batchTotalCount }}</span>
          <span>{{ batchProcessing ? '正在处理...' : '处理完成' }}</span>
        </div>
      </div>
    </transition>

    <!-- 读取结果 -->
    <div v-if="uploadResult" class="upload-result">
      <el-alert v-if="uploadResult.success" title="文件信息读取成功" type="success" :closable="false" show-icon>
        <template #default>

          <p v-for="(item, index) in filetitlelist" :key="index">{{ index + 1 }}. {{ item }}( 读取了 {{
            ricelist[index].length }} 条数据)</p>

          <p>{{ uploadResult.message || '文件信息已读取,可以查看数据预览' }}</p>
          <p>请查看控制台了解详细信息</p>
        </template>
      </el-alert>

      <el-alert v-else title="文件读取失败" type="error" :closable="false" show-icon>
        <template #default>
          {{ uploadResult.message }}
        </template>
      </el-alert>
    </div>

    <!-- 数据预览 -->
    <div v-if="rice.length > 0" class="data-preview">
      <el-card header="文件信息预览">
        <el-table :data="rice.slice(0, 10)" style="width: 100%" max-height="300">
          <el-table-column prop="id" label="编号" width="80" />
          <el-table-column prop="nametd" label="物资名称" width="150" />
          <el-table-column prop="typenumber" label="规格型号" width="120" />
          <el-table-column prop="pronumber" label="批次号" width="100" />
          <el-table-column prop="unit" label="单位" width="80" />
          <el-table-column prop="heavey" label="数量" width="80" />
          <el-table-column prop="address" label="存放地点" />
        </el-table>
        <div v-if="rice.length > 10" class="preview-tip">
          显示前10条信息,共 {{ rice.length }} 条
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  ElMessage,
  ElMessageBox,
} from 'element-plus';

import request from '@/api/api';
import { UploadFilled } from '@element-plus/icons-vue';

export default {
  name: 'uploadfile',
  components: {
    UploadFilled
  },
  data() {
    return {
      filetitlelist: [],
      ricelist: [],
      fileList: [],
      uploading: false,
      uploadResult: null,
      rice: [],
      findtage123: [],
      findtage123copy: [],
      findtage123all: [],
      filetitle: '',
      uploadingInventory: false,
      batchProcessing: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      isMiniProgram: /MicroMessenger/i.test(navigator.userAgent) && /miniProgram/i.test(navigator.userAgent),
      // 上传配置
      uploadUrl: 'https://abc.smbmhs.cn/bid/readerxlsx2',
      uploadHeaders: {
        'Content-Type': 'multipart/form-data'
      },
      uploadData: {
        type: 'file'
      },
      // 保存的文件夹句柄
      savedDirectoryHandle: null,
      // 批量进度相关
      batchProgress: 0,
      batchProgressVisible: false,
      batchProcessedCount: 0,
      batchTotalCount: 0,
      currentProcessingFile: '',
      progressColors: [
        { color: '#6DD5FA', percentage: 20 },
        { color: '#49A7F6', percentage: 50 },
        { color: '#5C7AFF', percentage: 80 },
        { color: '#7C3AED', percentage: 100 }
      ]
    }
  },
  mounted() {
    // 组件挂载时尝试恢复保存的文件夹句柄
    this.restoreDirectoryHandle()
  },
  computed: {
    batchProgressTitle() {
      if (!this.batchProgressVisible) {
        return '批量处理进度'
      }
      if (!this.batchTotalCount) {
        return '批量处理进度'
      }
      return this.batchProcessing ? '批量处理中' : '批量处理完成'
    }
  },
  methods: {
    startBatchProgress(total) {
      this.batchTotalCount = total
      this.batchProcessedCount = 0
      this.batchProgress = 0
      this.currentProcessingFile = ''
      this.batchProgressVisible = total > 0
    },

    updateBatchProgress(increment = 1) {
      if (!this.batchTotalCount) return
      this.batchProcessedCount = Math.min(this.batchTotalCount, this.batchProcessedCount + increment)
      this.batchProgress = Math.min(100, Math.round((this.batchProcessedCount / this.batchTotalCount) * 100))
    },

    finishBatchProgress() {
      if (!this.batchProgressVisible) return
      this.batchProgress = 100
      this.currentProcessingFile = ''
      setTimeout(() => {
        this.batchProgressVisible = false
        this.batchProgress = 0
        this.batchProcessedCount = 0
        this.batchTotalCount = 0
      }, 800)
    },

    // 从 IndexedDB 恢复文件夹句柄
    async restoreDirectoryHandle() {
      try {
        if (!('showDirectoryPicker' in window)) {
          console.log('浏览器不支持 File System Access API')
          return
        }

        const dbName = 'fileDownloadDB'
        const storeName = 'directoryHandle'
        const key = 'savedDirectoryHandle'

        return new Promise((resolve, reject) => {
          const request = indexedDB.open(dbName, 1)

          request.onerror = () => {
            console.log('无法打开 IndexedDB')
            resolve(null)
          }

          request.onsuccess = (event) => {
            const db = event.target.result
            const transaction = db.transaction([storeName], 'readonly')
            const store = transaction.objectStore(storeName)
            const getRequest = store.get(key)

            getRequest.onsuccess = () => {
              if (getRequest.result) {
                // 尝试恢复文件夹句柄
                // 注意:文件夹句柄不能直接序列化,所以这里需要用户重新选择
                // 但我们可以保存一个标记,提示用户是否要使用上次的文件夹
                console.log('找到保存的文件夹记录')
                resolve(null)
              } else {
                resolve(null)
              }
            }

            getRequest.onerror = () => {
              resolve(null)
            }
          }

          request.onupgradeneeded = (event) => {
            const db = event.target.result
            if (!db.objectStoreNames.contains(storeName)) {
              db.createObjectStore(storeName)
            }
          }
        })
      } catch (error) {
        console.error('恢复文件夹句柄失败:', error)
        return null
      }
    },

    // 保存文件夹句柄到 IndexedDB(实际上保存权限提示)
    async saveDirectoryPermission() {
      try {
        const dbName = 'fileDownloadDB'
        const storeName = 'directoryHandle'
        const key = 'hasDirectoryPermission'

        return new Promise((resolve, reject) => {
          const request = indexedDB.open(dbName, 1)

          request.onerror = () => {
            reject(new Error('无法打开 IndexedDB'))
          }

          request.onsuccess = (event) => {
            const db = event.target.result
            const transaction = db.transaction([storeName], 'readwrite')
            const store = transaction.objectStore(storeName)
            const putRequest = store.put(true, key)

            putRequest.onsuccess = () => {
              console.log('文件夹权限已保存')
              resolve(true)
            }

            putRequest.onerror = () => {
              reject(new Error('保存文件夹权限失败'))
            }
          }

          request.onupgradeneeded = (event) => {
            const db = event.target.result
            if (!db.objectStoreNames.contains(storeName)) {
              db.createObjectStore(storeName)
            }
          }
        })
      } catch (error) {
        console.error('保存文件夹权限失败:', error)
      }
    },

    // 选择桌面文件夹
    async selectDesktopFolder() {
      try {
        if (!window.isSecureContext) {
          ElMessage.warning('需要在 HTTPS 或 http://localhost 环境中才能选择文件夹')
          return null
        }

        if (!('showDirectoryPicker' in window)) {
          ElMessage.warning('浏览器未提供文件夹选择接口,将使用默认下载方式')
          return null
        }

        const directoryHandle = await window.showDirectoryPicker({
          mode: 'readwrite',
          startIn: 'desktop' // 尝试从桌面开始
        })

        // 保存权限
        await this.saveDirectoryPermission()
        this.savedDirectoryHandle = directoryHandle

        ElMessage.success('已选择文件夹,后续文件将自动下载到此文件夹')
        return directoryHandle
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('用户取消了文件夹选择')
          return null
        }
        console.error('选择文件夹失败:', error)
        ElMessage.error('选择文件夹失败: ' + error.message)
        return null
      }
    },

    // 处理选择文件夹按钮点击
    async handleSelectFolder() {
      await this.selectDesktopFolder()
    },

    // 文件状态改变时的处理(文件选择后立即触发)
    handleFileChange(file, fileList) {
      console.log('文件状态改变:', file, fileList)
      // 注意: 这里不自动读取文件信息,避免重复读取
      // 文件信息只在点击"批量处理所有文件"按钮时才读取
    },

    // 批量处理所有文件
    async batchProcessFiles() {
      if (this.batchProcessing) {
        ElMessage.info('文件正在批量处理中,请稍候')
        return
      }

      try {
        if (this.fileList.length === 0) {
          ElMessage.warning('请先选择文件')
          return
        }

        this.batchProcessing = true
        this.startBatchProgress(this.fileList.length)

        console.log('🚀 开始批量处理文件:', this.fileList.length, '个文件')

        // 用于跟踪已处理的文件,避免重复处理
        const processedFiles = new Set()

        for (let i = 0; i < this.fileList.length; i++) {
          const file = this.fileList[i]
          this.currentProcessingFile = file.name
          const fileKey = `${file.name}_${file.size}_${file.lastModified}`

          // 检查文件是否已处理过
          if (processedFiles.has(fileKey)) {
            console.log(`⏭️ 跳过已处理的文件: ${file.name}`)
            this.updateBatchProgress()
            continue
          }

          console.log(`📁 处理第 ${i + 1}/${this.fileList.length} 个文件:`, file.name)

          try {
            // 读取文件信息,但不触发下载(shouldDownload = false)
            await this.readFileInfo(file.raw, false)

            // 标记文件已处理
            processedFiles.add(fileKey)

            console.log(`✅ 第 ${i + 1} 个文件处理完成`)

            // 处理完文件后,手动触发下载
            // 注意: 此时 this.findtage123all 和 this.rice 已经是当前文件处理后的数据
            if (this.findtage123all && this.findtage123all.length > 0) {
              await this.uploadventorycvs()
              console.log(`📥 第 ${i + 1} 个文件已下载`)
            }

            // 等待一小段时间再处理下一个文件
            if (i < this.fileList.length - 1) {
              await new Promise(resolve => setTimeout(resolve, 1000))
            }
          } catch (error) {
            console.error(`❌ 第 ${i + 1} 个文件处理失败:`, error)
            ElMessage.error(`文件 ${file.name} 处理失败`)
          } finally {
            this.updateBatchProgress()
          }
        }

        ElMessage.success(`批量处理完成! 共处理 ${processedFiles.size} 个文件`)
      } finally {
        this.currentProcessingFile = ''
        this.finishBatchProgress()
        this.batchProcessing = false
      }
    },

    // 文件验证(简化版)
    beforeUpload(file) {
      const allowedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
        'application/vnd.ms-excel', // xls
        'text/csv'] // csv
      const isAllowedType = allowedTypes.includes(file.type) ||
        file.name.toLowerCase().endsWith('.xlsx') ||
        file.name.toLowerCase().endsWith('.xls') ||
        file.name.toLowerCase().endsWith('.csv')

      if (!isAllowedType) {
        ElMessage.error('只能选择 xlsx/xls/csv 格式的文件!')
        return false
      }

      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        ElMessage.error('文件大小不能超过 10MB!')
        return false
      }

      return true // 允许文件选择
    },

    // 读取文件信息的方法
    async readFileInfo(file, shouldDownload = true) {
      // 文件验证已在 beforeUpload 中完成,这里直接读取
      // shouldDownload: 是否触发下载,默认为 true(兼容旧代码)
      try {
        console.log('🚀 开始读取文件:', file.name, 'shouldDownload:', shouldDownload)
        console.log('📁 文件信息:', {
          name: file.name,
          size: file.size,
          type: file.type,
          lastModified: file.lastModified
        })

        // 根据后端 @RequestBody MultipartFile file 调整请求方式
        const formData = new FormData()
        formData.append('file', file)  // 后端期望的参数名是 'file'

        console.log('🌐 发送请求到:', this.uploadUrl)
        console.log('📦 FormData 内容:', {
          file: file.name
        })
        console.log('🔧 后端接口信息:', {
          url: 'https://abc.smbmhs.cn/bid/readerxlsx2',
          method: 'POST',
          parameter: '@RequestBody MultipartFile file',
          note: '后端只接收文件参数,不需要额外的 type 参数'
        })

        // 使用完整的 URL
        const response = await request('/bid/readerxlsx2', 'post', formData)

        console.log('✅ 文件读取成功,API 返回数据:', response.data)
        console.log('📊 原始响应结构:', {
          response: response,
          data: response.data,
          dataType: typeof response.data
        })

        // 处理读取到的数据,传入文件名和 shouldDownload 参数
        // 获取文件名(去掉扩展名)
        const fileName = file.name.replace(/\.[^/.]+$/, '')
        this.processUploadData(response.data, shouldDownload, fileName)

        // ElMessage.success('文件信息读取成功!')

        // 显示读取结果
        this.uploadResult = {
          success: true,
          filetitle: this.filetitle,
          dataList: this.rice,
          message: '文件信息已读取,可以查看数据预览'
        }

      } catch (error) {
        console.error('❌ 文件读取失败:', error)
        console.error('🔍 完整错误对象:', error)
        console.error('📋 错误详情:', {
          message: error.message,
          code: error.code,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          headers: error.response?.headers,
          config: {
            url: error.config?.url,
            method: error.config?.method,
            baseURL: error.config?.baseURL,
            headers: error.config?.headers
          }
        })

        let errorMessage = '文件读取失败'
        if (error.response) {
          errorMessage = `服务器错误: ${error.response.status} ${error.response.statusText}`
          if (error.response.data) {
            console.log('服务器返回的错误数据:', error.response.data)
            errorMessage += ` - ${JSON.stringify(error.response.data)}`
          }
        } else if (error.request) {
          errorMessage = '网络请求失败,请检查网络连接'
        } else {
          errorMessage = error.message || '未知错误'
        }

        ElMessage.error(errorMessage)

        // 设置失败结果
        this.uploadResult = {
          success: false,
          message: errorMessage
        }
      }
    },

    // 文件数量超出限制
    handleExceed(files, fileList) {
      ElMessage.warning(`最多只能选择 10 个文件,当前选择了 ${files.length} 个文件,共选择了 ${files.length + fileList.length} 个文件`)
    },

    // 上传进度
    handleUploadProgress(event, file, fileList) {
      console.log('上传进度:', event.percent)
    },

    // 上传成功
    handleUploadSuccess(response, file, fileList) {
      this.uploading = false
      console.log('上传成功:', response)

      try {
        // 不触发下载,只有在批量处理时才下载
        // 获取文件名(去掉扩展名)
        const fileName = file.name ? file.name.replace(/\.[^/.]+$/, '') : ''
        this.processUploadData(response, false, fileName)

        this.uploadResult = {
          success: true,
          filetitle: this.filetitle,
          dataList: this.rice
        }

        // ElMessage.success('文件上传成功!')
      } catch (error) {
        console.error('数据处理失败:', error)
        this.uploadResult = {
          success: false,
          message: '数据处理失败'
        }
        ElMessage.error('数据处理失败')
      }
    },

    // 上传失败
    handleUploadError(error, file, fileList) {
      this.uploading = false
      console.error('上传失败:', error)

      this.uploadResult = {
        success: false,
        message: error.message || '上传失败,请重试'
      }

      ElMessage.error('文件上传失败!')
    },

    // 处理上传返回的数据
    processUploadData(data, shouldDownload = true, fileName = '') {
      // shouldDownload: 是否触发下载,默认为 true(兼容旧代码)
      // fileName: 文件名,用于设置 filetitle
      try {
        console.log('开始处理数据:', data, 'shouldDownload:', shouldDownload, 'fileName:', fileName)

        // 根据返回结构 JSON.parse(data.data).data 来获取实际数据
        let actualData
        if (typeof data === 'string') {
          // 如果 data 是字符串,需要先解析
          const parsedData = JSON.parse(data)
          actualData = parsedData.data
          console.log('解析后的数据:', parsedData)
        } else if (data && data.data) {
          // 如果 data 是对象且有 data 属性
          actualData = data.data
          console.log('直接获取 data 属性:', actualData)
        } else {
          // 如果 data 直接就是数组
          actualData = data
          console.log('data 直接是数组:', actualData)
        }

        console.log('实际数据列表:', actualData)

        if (!actualData || !Array.isArray(actualData)) {
          throw new Error('数据格式不正确,期望数组格式')
        }

        const dataList1 = actualData

        // 使用文件名作为 filetitle,如果没有传入文件名则使用默认值
        this.filetitle = fileName || `文件_${new Date().getTime()}`
        console.log(dataList1, 'dataList1', this.filetitle, 'filetitle')

        // 检查文件标题是否已存在,避免重复添加
        if (!this.filetitlelist.includes(this.filetitle)) {
          this.filetitlelist.push(this.filetitle)
        } else {
          console.log('⚠️ 文件标题已存在,跳过添加:', this.filetitle)
        }

        // 过滤掉批次号为空的记录
        let dataList = []
        dataList1.forEach(m => {
          // 获取编号或序号的值
          const numberValue = m['编号'] || m['序号']
          const heavyValue = m['数量'] || m['重量']

          // 判断 parseInt 后是否是有效数字(整数)
          const isnumber = numberValue !== undefined &&
            numberValue !== null &&
            numberValue !== '' &&
            !isNaN(parseInt(numberValue))

          // 判断 parseFloat 后是否是有效数字(可以是整数或浮点数)
          const parsedHeavy = parseFloat(heavyValue)
          const isheavy = heavyValue !== undefined &&
            heavyValue !== null &&
            heavyValue !== '' &&
            !isNaN(parsedHeavy) &&
            isFinite(parsedHeavy) // 确保是有限数字,排除 Infinity
          // 如果编号/序号是有效数字且批次号不为空,则添加到数据列表
          if (isnumber && isheavy) {
            dataList.push(m)
          }
        })

        console.log(dataList, 'dataList')
        // dataList.splice(0, 1) // 删除第一条标题数据
        // 转换数据格式
        let listall = []
        dataList.forEach(v => {
          listall.push({
            id: parseInt(v['编号']) || parseInt(v['序号']),
            wlid: v['物料编号'] || v['资产编码'] || v['报废审批表编号'],
            nametd: v['废旧物资名称'] || v['物资名称'] || v['资产名称'],
            typenumber: v['规格型号'] || v['型号规格'],
            prodetails: v['废旧物资情况描述'],
            pronumber: v['批次号'] || v['原资产编码'],
            unit: v['单位'] || v['计量单位'],
            heavey: v['数量'],
            buytime: v['购入时间'],
            address: v['废旧物资存放地点'] || v['物资存放地点'],
            details: v['备注'],
            detailsunit: v['备注(实际计量单位)']
          })
        })

        this.rice = listall
        this.ricelist.push(listall)
        console.log(listall, 'listall')

        // 提取唯一的产品名称
        let setlist = new Set()
        this.rice.forEach(v => {
          setlist.add(v.nametd)
        })
        let lists = [...setlist.values()]
        this.findtage123 = lists.map(v => ({
          value: v
        }))
        this.findtage123copy = [...this.findtage123]

        console.log('rice', this.rice, this.findtage123)

        // 触发模糊搜索,传入 shouldDownload 参数
        this.fuzzySearchall(shouldDownload)

      } catch (error) {
        console.error('数据处理失败:', error)
        console.error('原始数据:', data)
        throw error
      }
    },

    // 模糊搜索方法
    fuzzySearchall(shouldDownload = true) {
      // shouldDownload: 是否触发下载,默认为 true(兼容旧代码)
      this.findtage123all = []
      let list = [...this.rice]
      // console.log(list, 'list');
      this.findtage123 = this.findtage123copy.map(v => {
        // 使用map而不是forEach,因为forEach不返回值
        const newV = {
          ...v
        }; // 创建新对象避免修改原数据
        // 获取过滤后的list
        // 过滤出与当前名称匹配的条目,filter 回调必须返回布尔值
        newV.list = this.rice.filter(s => {
          // 只保留名字相等的项
          if (s.nametd == v.value) {

            return true
          }

        })
        // console.log(this.rice, ' this.rice');




        return newV;
      });





      console.log(this.findtage123, 'this.findtage123拆解');
      let findtage123all = []
      this.findtage123.map(v => {
        const ids = v.list.map(m => parseInt(m.id))
        const heavey = v.list.reduce((sum, m) => sum + parseFloat(m.heavey), 0)
        const lastabj = {
          ...v.list[v.list.length - 1]
        }

        // 合并连续数字为范围
        const sortedIds = [...new Set(ids)].sort((a, b) => a - b)
        const ranges = []
        let start = sortedIds[0]
        let end = sortedIds[0]

        for (let i = 1; i < sortedIds.length; i++) {
          if (sortedIds[i] === end + 1) {
            end = sortedIds[i]
          } else {
            ranges.push(start === end ? start.toString() : `${start}-${end}`)
            start = end = sortedIds[i]
          }
        }
        ranges.push(start === end ? start.toString() : `${start}-${end}`)
        if (lastabj.unit == "吨") {
          lastabj.heavey = parseFloat(heavey).toFixed(4)

        } else {
          lastabj.heavey = parseFloat(heavey).toFixed(0)

        }
        lastabj.id = ranges.join(',')

        // 对于特殊名称 '废旧其他配件', 将该组所有项的 prodetails 合并、去重并拼接为字符串
        if (v.value === '废旧其他配件' || v.value === '废旧其他办公类用品') {
          const allDetails = v.list
            .map(item => item.prodetails)
            .filter(d => d !== undefined && d !== null)
            // .flatMap(d => Array.isArray(d) ? d : String(d).split(','))
            .map(s => String(s).trim())
            .filter(s => s && s !== 'undefined' && s !== 'null')

          const uniqueDetails = [...new Set(allDetails)]
          let uniqueDetails2 = uniqueDetails
          uniqueDetails.map(str => {
            let number = 0;
            let unit = ''
            v.list.map(item => {
              if (item.prodetails === str) {
                number += parseFloat(item.heavey);
                unit = item.unit
              }
            })
            uniqueDetails2.forEach((s, index) => {
              if (s === str) {
                uniqueDetails2[index] = `${str} (${number.toFixed(0)}${unit})`;
              }
            });
            // 对每个字符串进行处理的逻辑
            console.log('处理的 prodetails 字符串:', str)
            // 这里可以添加更多处理逻辑
          })

          lastabj.prodetails = uniqueDetails2.join(',')
          console.log(allDetails, 'allDetails');

        }

        findtage123all.push(lastabj)
      })

      this.findtage123all = findtage123all

      // 只有在 shouldDownload 为 true 时才调用 uploadventorycvs 触发下载
      if (shouldDownload) {
        this.uploadventorycvs()
      }
      console.log(findtage123all, 'findtage123all');

    },
    // url: `https://abc.smbmhs.cn/bid/uploadlogcvs`,data: {
    // 	list: this.findtage123all,
    // 	title:  this.filetitle
    // },
    // 上传库存 CSV 数据
    async uploadventorycvs() {
      this.uploadingInventory = true
      try {
        console.log('🚀 开始上传库存数据...')
        console.log('📊 上传数据:', {
          list: this.findtage123all,
          title: this.filetitle,
          count: this.findtage123all.length
        })
        console.log(this.rice, 'this.rice');

        const response = await request('/bid/uploadlogcvs', 'post', {
          list: this.findtage123all,
          list2: this.rice, // 从索引2开始到结尾的所有元素
          title: this.filetitle
        })

        console.log('✅ 文件处理成功:', response.data)

        // 处理 base64 数据并下载文件
        if (response.data && response.data.data) {
          const base64Data = response.data.data.toString().trim().replace(/\s/g, '')
          console.log('📄 获取到 base64 数据:', base64Data.substring(0, 100) + '...')

          // 下载文件
          this.downloadFileFromBase64(base64Data, `${this.filetitle}(已处理)`)
          // ElMessage.success('文件处理成功,文件已下载!')
        } else {
          // ElMessage.success('文件处理成功!')
        }

        return response.data

      } catch (error) {
        console.error('❌ 库存数据上传失败:', error)
        console.error('🔍 错误详情:', {
          message: error.message,
          code: error.code,
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data
        })

        let errorMessage = '库存数据上传失败'
        if (error.response) {
          errorMessage = `服务器错误: ${error.response.status} ${error.response.statusText}`
          if (error.response.data) {
            console.log('服务器返回的错误数据:', error.response.data)
            errorMessage += ` - ${JSON.stringify(error.response.data)}`
          }
        } else if (error.request) {
          errorMessage = '网络请求失败,请检查网络连接'
        } else {
          errorMessage = error.message || '未知错误'
        }

        ElMessage.error(errorMessage)
        throw error
      } finally {
        this.uploadingInventory = false
      }
    },

    // 从 base64 数据下载文件(手机端兼容版)
    downloadFileFromBase64(base64Data, filename) {
      try {
        console.log('📥 开始下载文件:', filename)
        console.log('📱 设备信息:', {
          userAgent: navigator.userAgent,
          isMobile: this.isMobile,
          isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
          isAndroid: /Android/.test(navigator.userAgent)
        })

        // 检测文件类型
        let mimeType = 'application/octet-stream'
        let fileExtension = '.csv'

        // 根据 base64 数据头判断文件类型
        if (base64Data.startsWith('data:')) {
          // 如果包含 data URL 前缀,提取 MIME 类型
          const mimeMatch = base64Data.match(/^data:([^;]+);base64,/)
          if (mimeMatch) {
            mimeType = mimeMatch[1]
            base64Data = base64Data.replace(/^data:[^;]+;base64,/, '')

            // 根据 MIME 类型确定文件扩展名
            if (mimeType.includes('csv')) {
              fileExtension = '.csv'
            } else if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) {
              fileExtension = '.xlsx'
            } else if (mimeType.includes('pdf')) {
              fileExtension = '.pdf'
            }
          }
        }

        // 确保文件名有正确的扩展名
        if (!filename.includes('.')) {
          filename += fileExtension
        }

        console.log('📄 文件信息:', {
          filename: filename,
          mimeType: mimeType,
          base64Length: base64Data.length
        })

        // 根据设备类型选择下载方式

        this.downloadForDesktop(base64Data, filename, mimeType)


      } catch (error) {
        console.error('❌ 文件下载失败:', error)
        ElMessage.error('文件下载失败: ' + error.message)
      }
    },

    // 桌面端下载方法(支持自动下载到桌面文件夹)
    async downloadForDesktop(base64Data, filename, mimeType) {
      try {
        // 将 base64 转换为 Blob
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })

        // 尝试使用 File System Access API 保存到指定文件夹
        // 只有在用户已经选择文件夹的情况下才使用
        if (this.savedDirectoryHandle && 'showDirectoryPicker' in window) {
          try {
            // 尝试保存文件到选择的文件夹(如果句柄无效会在这里失败)
            const fileHandle = await this.savedDirectoryHandle.getFileHandle(filename, { create: true })
            const writable = await fileHandle.createWritable()
            await writable.write(blob)
            await writable.close()

            console.log('✅ 文件已保存到指定文件夹:', filename)
            // ElMessage.success('文件已自动下载到桌面文件夹!')
            return
          } catch (writeError) {
            // 写入失败,可能是句柄无效,清除句柄并使用默认下载方式
            console.log('写入文件失败,可能是文件夹句柄无效:', writeError)
            this.savedDirectoryHandle = null
            ElMessage.warning('文件夹句柄已失效,请重新选择文件夹.本次使用默认下载方式.')
            // 继续执行默认下载方式
          }
        }

        // 默认下载方式(浏览器默认下载文件夹)
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.style.display = 'none'

        // 触发下载
        document.body.appendChild(link)
        link.click()

        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 1000)

        console.log('✅ 桌面端文件下载完成:', filename)
        // ElMessage.success('文件下载成功!')

      } catch (error) {
        console.error('❌ 桌面端下载失败:', error)
        ElMessage.error('桌面端下载失败: ' + error.message)
      }
    },

    // 检查是否有文件夹权限
    async checkDirectoryPermission() {
      try {
        const dbName = 'fileDownloadDB'
        const storeName = 'directoryHandle'
        const key = 'hasDirectoryPermission'

        return new Promise((resolve) => {
          const request = indexedDB.open(dbName, 1)

          request.onerror = () => {
            resolve(false)
          }

          request.onsuccess = (event) => {
            const db = event.target.result
            if (!db.objectStoreNames.contains(storeName)) {
              resolve(false)
              return
            }
            const transaction = db.transaction([storeName], 'readonly')
            const store = transaction.objectStore(storeName)
            const getRequest = store.get(key)

            getRequest.onsuccess = () => {
              resolve(!!getRequest.result)
            }

            getRequest.onerror = () => {
              resolve(false)
            }
          }

          request.onupgradeneeded = (event) => {
            const db = event.target.result
            if (!db.objectStoreNames.contains(storeName)) {
              db.createObjectStore(storeName)
            }
          }
        })
      } catch (error) {
        console.error('检查文件夹权限失败:', error)
        return false
      }
    },

    // 手机端下载方法
    downloadForMobile(base64Data, filename, mimeType) {
      try {
        console.log('📱 使用手机端下载方法')
        console.log('🔍 环境检测:', {
          isMobile: this.isMobile,
          isMiniProgram: this.isMiniProgram,
          userAgent: navigator.userAgent
        })

        // 小程序环境优先尝试直接打开,失败后显示复制界面




        // 方法2: 使用 data URL 在新窗口打开
        // if (this.tryDataUrlDownload(base64Data, filename, mimeType)) {
        //   return
        // }

        // 方法3: 显示 base64 数据让用户手动复制
        this.showBase64Data(base64Data, filename)

      } catch (error) {
        console.error('❌ 手机端下载失败:', error)
        // 降级到显示 base64 数据
        this.showBase64Data(base64Data, filename)
      }
    },

    // 尝试使用 Blob 下载
    tryBlobDownload(base64Data, filename, mimeType) {
      try {
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })

        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.style.display = 'none'

        // 添加到页面并触发点击
        document.body.appendChild(link)
        link.click()

        // 延迟清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 1000)

        console.log('✅ 手机端 Blob 下载完成:', filename)
        // ElMessage.success('文件下载成功!')
        return true
      } catch (error) {
        console.log('❌ Blob 下载失败:', error)
        return false
      }
    },

    // 尝试使用 data URL 下载
    tryDataUrlDownload(base64Data, filename, mimeType) {
      try {
        // 确保 base64Data 是纯 base64 字符串,不包含 data: 前缀
        let cleanBase64 = base64Data
        if (base64Data.startsWith('data:')) {
          // 如果已经包含 data: 前缀,直接使用
          cleanBase64 = base64Data
        } else {
          // 如果没有前缀,构建完整的 data URL
          cleanBase64 = `data:${mimeType};base64,${base64Data}`
        }

        console.log('📄 Data URL 信息:', {
          original: base64Data.substring(0, 50) + '...',
          mimeType: mimeType,
          dataUrl: cleanBase64.substring(0, 50) + '...'
        })

        const newWindow = window.open(cleanBase64, '_blank')

        if (newWindow) {
          console.log('✅ 手机端 data URL 下载完成:', filename)
          // ElMessage.success('文件已在新窗口中打开,请长按保存')
          return true
        } else {
          console.log('❌ 无法打开新窗口')
          return false
        }
      } catch (error) {
        console.log('❌ data URL 下载失败:', error)
        return false
      }
    },

    // 显示 base64 数据供用户手动处理
    showBase64Data(base64Data, filename) {
      // 创建模态框显示 base64 数据
      const modal = document.createElement('div')
      modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
      `

      const content = document.createElement('div')
      content.style.cssText = `
        background: white;
        padding: 20px;
        border-radius: 10px;
        max-width: 90%;
        max-height: 80%;
        overflow: auto;
        text-align: center;
      `

      content.innerHTML = `
        <h3 style="margin-bottom: 15px; color: #333;">手机端下载提示</h3>
        <p style="margin-bottom: 15px; color: #666;">由于手机端限制,无法直接下载文件</p>
        <p style="margin-bottom: 15px; color: #666;">请复制以下链接到浏览器中打开:</p>
        <textarea 
          readonly 
          style="width: 100%; height: 200px; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 12px; word-break: break-all;"
        >${base64Data.startsWith('data:') ? base64Data : 'data:text/csv;base64,' + base64Data}</textarea>
        <div style="margin-top: 15px;">
          <button onclick="const dataUrl = '${base64Data.startsWith('data:') ? base64Data : 'data:text/csv;base64,' + base64Data}'; const isMiniProgram = /MicroMessenger/i.test(navigator.userAgent) && /miniProgram/i.test(navigator.userAgent); if (isMiniProgram) { navigator.clipboard.writeText(dataUrl).then(() => { alert('已复制到剪贴板,请长按链接选择在浏览器中打开'); }); } else { navigator.clipboard.writeText(dataUrl).then(() => { alert('已复制到剪贴板,正在打开链接...'); window.open(dataUrl, '_blank'); }); }" 
                  style="padding: 10px 20px; background: #409eff; color: white; border: none; border-radius: 5px; margin-right: 10px;">
            ${this.isMiniProgram ? '复制链接' : '复制并打开链接'}
          </button>
          <button onclick="this.parentElement.parentElement.parentElement.remove()" 
                  style="padding: 10px 20px; background: #f56c6c; color: white; border: none; border-radius: 5px;">
            关闭
          </button>
        </div>
      `

      modal.appendChild(content)
      document.body.appendChild(modal)

      // 点击背景关闭
      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          document.body.removeChild(modal)
        }
      })

      ElMessage.info('由于手机端限制,已显示下载提示')
    },

    // 清空文件
    async clearFiles() {
      try {
        // 如果有文件正在处理,提示用户
        if (this.batchProcessing || this.uploadingInventory) {
          ElMessage.warning('文件正在处理中,请稍候再试')
          return
        }


        // 清空所有数据
        this.fileList = []
        this.filetitlelist = []
        this.ricelist = []
        this.uploadResult = null
        this.rice = []
        this.findtage123 = []
        this.findtage123copy = []
        this.findtage123all = []
        this.filetitle = ''
        this.uploading = false
        this.uploadingInventory = false
        this.batchProcessing = false

        // 重置上传组件
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }

        ElMessage.success('文件已清空')
        console.log('✅ 所有文件和数据已清空')
      } catch (error) {
        console.error('清空文件失败:', error)
        ElMessage.error('清空文件失败: ' + error.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.uploadfile {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.device-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding: 10px 15px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.device-detail {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.upload-demo {
  margin-bottom: 20px;
}

.upload-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.batch-progress-panel {
  background: linear-gradient(135deg, #f5f9ff 0%, #eef2ff 100%);
  border-radius: 14px;
  padding: 18px 22px;
  box-shadow: 0 10px 30px rgba(92, 122, 255, 0.12);
  margin-bottom: 20px;
  border: 1px solid rgba(124, 58, 237, 0.08);
}

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 600;
  color: #303133;
}

.current-file {
  font-size: 13px;
  color: #909399;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

.progress-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 13px;
  color: #606266;
}

::deep(.batch-progress-panel .el-progress-bar__innerText) {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.upload-result {
  margin-bottom: 20px;
}

.data-preview {
  margin-top: 20px;
}

.preview-tip {
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-top: 10px;
}

:deep(.el-upload-dragger) {
  width: 100%;
  height: 180px;
}

.upload-trigger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

:deep(.el-icon--upload) {
  font-size: 67px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

:deep(.el-upload__text) {
  color: #606266;
  font-size: 14px;
  text-align: center;

  em {
    color: #409eff;
    font-style: normal;
  }
}

:deep(.el-upload__tip) {
  color: #606266;
  font-size: 12px;
  text-align: center;
  margin-top: 7px;
}
</style>